import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Fragment } from "react";
import React from "react";

function HandleRedirection() {
  const history = useHistory();
  const location = useLocation();
  
  useEffect(() => {
    if (location?.pathname === "/index.html") {
      const searchParams = new URLSearchParams(window.location.search);
      let rUri = "/";
      if (searchParams.get("redirect")) {
        rUri += searchParams.get("redirect") || "";
        searchParams.delete("redirect");
      }
      rUri =
        rUri + (searchParams.toString() ? "?" + searchParams.toString() : "");
      history.push(rUri);
    }
  }, [location.pathname]);
  
  return <Fragment />;
}

export default HandleRedirection;